import { render } from "./AppCarrusel.vue?vue&type=template&id=1f1ba7b5&scoped=true"
import script from "./AppCarrusel.vue?vue&type=script&lang=js"
export * from "./AppCarrusel.vue?vue&type=script&lang=js"

import "./AppCarrusel.vue?vue&type=style&index=0&id=1f1ba7b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1ba7b5"]])

export default __exports__